import { injectGlobal } from "emotion";
import globals from "./base";

// font-family: 'Rubik', sans-serif;
injectGlobal`
  ${globals}
`;
